//

import Scroller from "../util/scroller";

export default {
    init() {
        var recipes = {
            list_item: document.querySelectorAll(".list-item--recipe"),
            scroller: [],
            callback: function () {
                this.classList.add("is-visible");
            },
        };

        for (var i = 0; i < recipes.list_item.length; i++) {
            recipes.scroller[i] = new Scroller(recipes.list_item[i], {
                callback: recipes.callback,
                once: true,
                triggerOffset: -125,
            });
        }
    },
    finalize() {},
};



// WEBPACK FOOTER //
// ./js/routes/post-type-archive-products.js